import { useState } from "react";
import { useLocale } from "../../i18n/LocaleProvider";
import { workflowText } from "../../lib/workflowList";
import type { WorkflowListState } from "../../workflows/useWorkflowSections";
import { SettingsIcon } from "./SettingsIcon";

export function BetaFeaturesCard({ list, enabledIds, onChange }: {
  list: WorkflowListState;
  enabledIds: readonly string[];
  onChange: (id: string, enabled: boolean) => void;
}) {
  const { t, locale } = useLocale();
  const [error, setError] = useState(false);
  const items = list.kind === "ok" ? list.workflows.filter((item) => item.state === "open") : [];
  return (
    <div className="settings-card beta-features">
      <h3 className="settings-card-title"><SettingsIcon name="beta" />{t("settings.beta.title")}</h3>
      <p className="settings-note settings-description">{t("settings.beta.description")}</p>
      {items.map((item) => {
        const { title, description } = workflowText(item, locale);
        return (
          <div key={item.id} className="beta-feature-row">
            <div className="beta-feature-copy">
              <label className="beta-feature-name" htmlFor={`beta-switch-${item.id}`}>{title}</label>
              <span className="info-tip" tabIndex={0} role="note" aria-label={description}
                aria-describedby={`beta-description-${item.id}`}
                onKeyDown={(event) => { if (event.key === "Escape") event.currentTarget.blur(); }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" />
                  <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2-3 4" />
                  <circle cx="12" cy="17" r=".8" fill="currentColor" stroke="none" />
                </svg>
                <span className="info-tip-bubble" role="tooltip" id={`beta-description-${item.id}`}>{description}</span>
              </span>
            </div>
            <span className="skill-switch">
              <input id={`beta-switch-${item.id}`} type="checkbox" role="switch" aria-label={title}
                aria-describedby={`beta-description-${item.id}`}
                checked={enabledIds.includes(item.id)}
                onChange={(event) => {
                  try { onChange(item.id, event.target.checked); setError(false); }
                  catch { setError(true); }
                }} />
              <span className="skill-switch-track" aria-hidden="true" />
            </span>
          </div>
        );
      })}
      {items.length === 0 ? <p className="settings-note beta-feature-status">{t(
        list.kind === "loading" ? "chat.loading" : list.kind === "ok" ? "settings.beta.empty" : "settings.beta.unavailable"
      )}</p> : null}
      {error ? <p role="alert" className="settings-msg err">{t("settings.beta.saveFailed")}</p> : null}
    </div>
  );
}
